import { Modal, Button, Row, Col } from "react-bootstrap";
import moment from "moment";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import axios from "axios";
import { toast } from "react-toastify";
import { useState } from "react";

const AMCViewModal = ({ show, handleClose, amcData }) => {
  const userPermissions = localStorage.getItem("user_permissions");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownload = async () => {
    setDownloadLoading(true);
    try {
      const url = `${BASE_URL}/api/amc/${amcData.id}/pdf/`;

      const mimeType = "application/pdf";
      const fileName = `AMC_${amcData.amcName}.pdf`;

      const response = await axios.get(url, {
        responseType: "blob",
        headers: HEADERS,
      });
      const blob = new Blob([response.data], { type: mimeType });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();

      toast.success("AMC downloaded successfully!");
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      } else {
        toast.error("Download failed");
      }
    } finally {
      setDownloadLoading(false);
    }
  };
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Modal.Title>AMC Report Details</Modal.Title>
          {userPermissions?.includes("amc_can_download_amc") && (
            <Button
              variant="primary"
              size="sm"
              onClick={handleDownload}
              disabled={downloadLoading}
              style={{ marginLeft: "auto" }}
            >
              Download
            </Button>
          )}
        </div>
      </Modal.Header>

      <Modal.Body>
        {amcData ? (
          <div>
            {amcData.customer && (
              <>
                <h5 className="mb-3">Customer Details</h5>
                <Row>
                  <Col md={6}>
                    <p>
                      <strong>Customer Name:</strong>{" "}
                      {amcData.customer.customer_name || "NA"}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Customer Number:</strong>{" "}
                      {amcData.customer.phone_number || "NA"}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Customer Email:</strong>{" "}
                      {amcData.customer.email || "NA"}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Landmark:</strong>{" "}
                      {amcData.customer.landmark_paci || "NA"}
                    </p>
                  </Col>
                  <Col md={6}>
                    <p>
                      <strong>Address:</strong>{" "}
                      {amcData.customer.primary_address || "NA"}
                    </p>
                  </Col>
                </Row>
              </>
            )}

            {(amcData.productBrand ||
              amcData.brand?.name ||
              amcData.serialModelNo ||
              amcData.underWarranty ||
              amcData.serviceAmount !== undefined ||
              amcData.remainingAmount !== undefined) && (
              <>
                <h5 className="mt-4 mb-3">Product Details</h5>
                <Row>
                  {amcData.brand?.name && (
                    <Col md={6}>
                      <p>
                        <strong>Product Name:</strong> {amcData.brand?.name}
                      </p>
                    </Col>
                  )}
                  {amcData.productBrand && (
                    <Col md={6}>
                      <p>
                        <strong>Product Brand:</strong> {amcData.productBrand}
                      </p>
                    </Col>
                  )}

                  {amcData.serialModelNo && (
                    <Col md={6}>
                      <p>
                        <strong>Serial Number:</strong> {amcData.serialModelNo}
                      </p>
                    </Col>
                  )}
                  {amcData.underWarranty !== undefined && (
                    <Col md={6}>
                      <p>
                        <strong>Under Warranty:</strong>{" "}
                        {amcData.underWarranty ? "Yes" : "No"}
                      </p>
                    </Col>
                  )}
                  {amcData.serviceAmount !== undefined && (
                    <Col md={6}>
                      <p>
                        <strong>Service Amount:</strong> {amcData.serviceAmount}
                      </p>
                    </Col>
                  )}
                  {amcData.remainingAmount !== undefined && (
                    <Col md={6}>
                      <p>
                        <strong>Remaining Amount:</strong>{" "}
                        {amcData.remainingAmount}
                      </p>
                    </Col>
                  )}
                </Row>
              </>
            )}

            {(amcData.amcName ||
              amcData.activationDate ||
              amcData.no_of_service ||
              amcData.remainder ||
              amcData.select_service_occurence ||
              amcData.serviceCompleted !== undefined ||
              amcData.status) && (
              <>
                <h5 className="mt-4 mb-3">AMC Details</h5>
                <Row>
                  {amcData.amcName && (
                    <Col md={6}>
                      <p>
                        <strong>AMC Name:</strong> {amcData.amcName}
                      </p>
                    </Col>
                  )}
                  {amcData.activationDate && (
                    <Col md={6}>
                      <p>
                        <strong>Activation Date:</strong>{" "}
                        {moment(amcData.activationDate).format("YYYY-MM-DD")}
                      </p>
                    </Col>
                  )}
                  {amcData.expiry && (
                    <Col md={6}>
                      <p>
                        <strong>Expiry Date</strong>{" "}
                        {moment(amcData.expiry).format("YYYY-MM-DD")}
                      </p>
                    </Col>
                  )}
                  {amcData.no_of_service && (
                    <Col md={6}>
                      <p>
                        <strong>No. of Services:</strong>{" "}
                        {amcData.no_of_service}
                      </p>
                    </Col>
                  )}
                
                  {amcData.select_service_occurence && (
                    <Col md={6}>
                      <p>
                        <strong>Service Occurrence:</strong>{" "}
                        {amcData.select_service_occurence}
                      </p>
                    </Col>
                  )}
                  {amcData.serviceCompleted !== undefined && (
                    <Col md={6}>
                      <p>
                        <strong>Service Completed:</strong>{" "}
                        {amcData.serviceCompleted}
                      </p>
                    </Col>
                  )}
                  {amcData.status && (
                    <Col md={6}>
                      <p>
                        <strong>Status:</strong> {amcData.status}
                      </p>
                    </Col>
                  )}
                </Row>
              </>
            )}

            {amcData.note && (
              <>
                <h5 className="mt-4 mb-3">Note</h5>
                <p>{amcData.note}</p>
              </>
            )}

            {amcData.service &&
              (amcData.service.service_name ||
                amcData.service.service_description ||
                amcData.service.service_contact_number) && (
                <>
                  <h5 className="mt-4 mb-3">Service Details</h5>
                  <Row>
                    {amcData.service.service_name && (
                      <Col md={6}>
                        <p>
                          <strong>Services:</strong>{" "}
                          {amcData.service.service_name}
                        </p>
                      </Col>
                    )}
                    {amcData.service.service_description && (
                      <Col md={6}>
                        <p>
                          <strong>Service Description:</strong>{" "}
                          {amcData.service.service_description}
                        </p>
                      </Col>
                    )}
                    {amcData.service.service_contact_number && (
                      <Col md={6}>
                        <p>
                          <strong>Service Contact Number:</strong>{" "}
                          {amcData.service.service_contact_number}
                        </p>
                      </Col>
                    )}
                  </Row>
                </>
              )}
          </div>
        ) : (
          <p>No details available.</p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AMCViewModal;
